import { dateFormat } from '@/utils'

const filtersFormatDate = {
  filters: {
    formatDate(value, fmt) {
      if (!value) {
        return ''
      }
      return dateFormat(value, fmt)
    },
  },
}

export default filtersFormatDate
